import React, { useState, useRef } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export default function CreditToGC({ creditsBalance, goldCoinsBalance, token, onConverted }) {
    const [open, setOpen] = useState(false);
    const [amount, setAmount] = useState('');
    const [review, setReview] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const requestId = useRef(null);
    const submitting = useRef(false);
    const units = Number(amount);
    const valid = /^\d+(?:\.\d{1,2})?$/.test(amount) && units > 0 && units <= Number(creditsBalance);
    const format = value => Number(value || 0).toFixed(2);

    const convert = async () => {
        if (submitting.current || !valid) return;
        submitting.current = true; setBusy(true); setError('');
        try {
            const response = await fetch(`${API_URL}/credits-pool/convert-credits-to-gc`, {
                method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({ amount, requestId: requestId.current }),
            });
            const data = await response.json();
            if (!response.ok || !data.success) throw new Error(data.error || 'Conversion failed. Retry this request.');
            setMessage(`Converted ${format(data.amount)} Credits to ${format(data.amount)} GC.`);
            setAmount(''); setReview(false); requestId.current = null;
            onConverted(data);
        } catch (failure) {
            setError(failure.message || 'Could not reach the server. Retry this request.');
        } finally {
            submitting.current = false; setBusy(false);
        }
    };
    return <>
        <button className="btn btn-secondary" onClick={() => { setOpen(true); setError(''); setMessage(''); }}>Convert Credits to GC</button>
        {open && <div className="system-confirm-overlay">
            <div className="system-confirm-modal" style={{ width: 'min(100%, 560px)' }} role="dialog" aria-modal="true" aria-labelledby="credit-gc-title">
                <div className="system-confirm-body" style={{ gridColumn: '1 / -1', display: 'grid', gap: 12 }}>
                    <h3 id="credit-gc-title">Convert Credits to GC</h3>
                    <p>1 Credit = 1 GC. Conversion works from Credits to GC.</p>
                    <p>Available: {format(creditsBalance)} Credits · {format(goldCoinsBalance)} GC</p>
                    <label className="form-label" htmlFor="credit-gc-amount">Credits to convert</label>
                    <input id="credit-gc-amount" className="form-input" inputMode="decimal" value={amount} disabled={busy || review} placeholder="e.g. 10" onChange={e => { setAmount(e.target.value); setReview(false); requestId.current = null; setError(''); setMessage(''); }} />
                    {valid && <p>You receive <strong>{format(units)} GC</strong>. After conversion: {format(Number(creditsBalance) - units)} Credits · {format(Number(goldCoinsBalance) + units)} GC.</p>}
                    {amount && !valid && <p role="alert">Enter an amount above zero, within your Credits balance, with up to two decimal places.</p>}
                    {error && <p role="alert">{error}</p>}
                    {message && <p role="status">{message}</p>}
                </div>
                <div className="system-confirm-actions" style={{ flexWrap: 'wrap' }}>
                    <button className="btn btn-secondary" disabled={busy} onClick={() => setOpen(false)}>Close</button>
                    {review && <button className="btn btn-secondary" disabled={busy} onClick={() => { setReview(false); requestId.current = null; }}>Change amount</button>}
                    <button className="btn btn-primary" disabled={busy || !valid} onClick={() => {
                        if (review) convert();
                        else { requestId.current = crypto.randomUUID(); setReview(true); }
                    }}>{busy ? 'Converting…' : review ? `Confirm ${format(units)} Credits → ${format(units)} GC` : 'Review conversion'}</button>
                </div>
            </div>
        </div>}
    </>;
}
